import styled from 'styled-components';
import { Button, Radio } from 'antd';
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const StyledButton = styled(Button)`
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 8px 16px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  border: 1px solid ${(props) => getThemeValue(props, '#718096', '#d9d9d9')} !important;
  background-color: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
  box-shadow: ${(props) =>
    getThemeValue(
      props,
      '0 1px 2px rgba(0, 0, 0, 0.3)',
      '0 1px 2px rgba(0, 0, 0, 0.1)'
    )} !important;
  transition: all 0.2s ease !important;

  &:hover {
    border-color: ${(props) => getThemeValue(props, '#718096', '#40a9ff')} !important;
    background-color: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
  }

  &:focus {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  .anticon {
    color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
  }
`;

export const DropdownContainer = styled.div`
  background: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  border-radius: 6px !important;
  padding: 16px !important;
  width: 200px !important;
  box-shadow: ${(props) =>
    getThemeValue(
      props,
      '0 4px 12px rgba(0, 0, 0, 0.5)',
      '0 4px 12px rgba(0, 0, 0, 0.15)'
    )} !important;
  border: 1px solid ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
`;

export const DropdownTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const RadioItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const RadioItemLabel = styled.span`
  font-size: 14px;
  color: ${(props) => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const IconWrapper = styled.div`
  font-size: 20px;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${(props) => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  margin: 8px 0;
`;

export const StyledRadio = styled(Radio)`
  pointer-events: none; /* Prevent double-click, parent handles click */

  .ant-radio-inner {
    border-color: ${(props) => getThemeValue(props, '#718096', '#d9d9d9')} !important;
    background-color: ${(props) => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #14b8a6 !important;
    background-color: #14b8a6 !important;
  }

  .ant-radio-checked .ant-radio-inner::after {
    background-color: #ffffff !important;
  }

  &:hover .ant-radio-inner {
    border-color: #14b8a6 !important;
  }
`;

export const ButtonTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;

export const ButtonLabel = styled.span`
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;

export const ButtonValue = styled.span`
  font-weight: 600;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;
